import { render } from "./ChoreManagement.vue?vue&type=template&id=5b0f403e&scoped=true"
import script from "./ChoreManagement.vue?vue&type=script&lang=js"
export * from "./ChoreManagement.vue?vue&type=script&lang=js"

import "./ChoreManagement.vue?vue&type=style&index=0&id=5b0f403e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0f403e"]])

export default __exports__